export const formatCurrency = (
  value: number,
  locale: string,
  options: Intl.NumberFormatOptions,
) => {
  const formatter = new Intl.NumberFormat(locale, {
    style: "currency",
    ...options,
  });
  return formatter.format(value);
};

export const formatPercentage = (
  value: number,
  locale: string,
  options: Intl.NumberFormatOptions = {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  },
) => {
  const formatter = new Intl.NumberFormat(locale, {
    style: "percent",
    ...options,
  });
  return formatter.format(value);
};

// Rounds to avoid floating-point artifacts (e.g. 0.29 * 100 = 28.999999999999996)
export const toCents = (amount: number) => Math.round(amount * 100);
